import { render } from "./CollageHero.vue?vue&type=template&id=00ab1576"
import script from "./CollageHero.vue?vue&type=script&lang=js"
export * from "./CollageHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/collage-hero/CollageHero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00ab1576"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00ab1576', __exports__)) {
    api.reload('00ab1576', __exports__)
  }
  
  module.hot.accept("./CollageHero.vue?vue&type=template&id=00ab1576", () => {
    api.rerender('00ab1576', render)
  })

}


export default __exports__